import SubmissionError from '../../../error/SubmissionError.js'

export const SET_ERROR = 'SET_ERROR'

export const handleApiError = ({commit, dispatch}, error, violationHandler = 'setViolations') => {
  if (error instanceof SubmissionError) {
    dispatch(violationHandler, error.errors)
    commit(SET_ERROR, error.errors._error)
    return
  }

  commit(SET_ERROR, error)
}
export function itemEmpty(properties) {
  const item = {}
  Object.keys(properties).map((property) => {
    if (properties[property].type === 'array') {
      item[property] = []
      return
    }
    item[property] = null
  })
  return item
}
